import  { Component } from 'react';
// import PropTypes from 'prop-types';
import getRoutes from './routes.LB';

class Root extends Component {
  render() {
    const { store } = this.props;
    return getRoutes(store);
  }
}

// Root.propTypes = {
//   store: PropTypes.object,
// };

// Root.defaultProps = {
//   store: null,
// }; 

export default Root;
